import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=64856b12&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=64856b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.108.4_postcss@8.5.19___ejs@3.1.10_lodash@4.18._z5rsh3vccqgauevuorosu7p4fm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64856b12",
  null
  
)

export default component.exports